module.exports = __webpack_public_path__ + "img/img31.c59e2664.png";